angular.module('rjmNg.constants').constant 'tourTypes', Object.freeze
  VRB_TOUR: 14
  DASH_TOUR: 16
